import Vue from 'vue';
import App from './App.vue';
import VueScrollTo from 'vue-scrollto';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import store from './store';
import { mapActions } from 'vuex';
import router from './router/AppRouter.js';
import VuePlyr from 'vue-plyr'

Vue.config.productionTip = false;
Vue.use(VuePlyr, {
  plyr: {
    fullscreen: { enabled: true }
  },
  emit: ['ended']
})
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

Vue.use(BootstrapVue);

new Vue({
  store,
  methods: {
    ...mapActions(['fetchCollections', 'fetchColors', 'fetchFontSettings'])
  },
  created() {
    this.fetchColors(),
    this.fetchFontSettings();
    this.fetchCollections(),
      window.addEventListener('load', function () {
        AOS.init({
          disable: function () {
            return window.innerWidth > 768;
          }
        });

      });
  },
  router,
  render: h => h(App)
}).$mount('#app');
